export const LANG_PREFIX = 'lang::';
